
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import moment, { Moment } from 'moment';
    import { Wait } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Articulo() { return this.Controlador.Articulo; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public Descripcion: string = '';
        public UltimaModificacion: Moment = null;
        @Prop()
        public Abierto: boolean;
        @Watch( 'Abierto' )
        onAbierto()
        {
            if ( this.Abierto && !this.Iniciado )
                this.Iniciar();
        }

        public Iniciado: boolean = false;
        public Cargando: boolean = false;
        public Guardando: boolean = false;
        public Error: boolean = false;

        public Ok()
        {
            return this.Descripcion != this.Articulo.Descripcion;
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Iniciar();
        }

        async Iniciar()
        {
            this.Cargando = true;

            this.Descripcion = '';
            this.UltimaModificacion = null;

            if ( !this.Articulo )
                return;

            await Wait( 300 );
            let e = await this.Articulo.CargarDescripcion();
            if ( e )
            {
                this.Iniciado = true;
                this.UltimaModificacion = e.Fecha;
                this.Descripcion = e.Descripcion;
            }
            this.Cargando = false;
        }


        async Guardar()
        {
            this.Guardando = true;
            let e = await this.Articulo.GuardarDescripcion( this.Descripcion );
            if ( e )
            {
                this.UltimaModificacion = moment();
            } else
            {
                this.Error = true;
            }
            this.Guardando = false;
        }
    }
